// Global Welcome Tour constants

// Tour IDs
export const WELCOME_TOUR_ID = 'welcome-tour';

// Segment IDs
export const WELCOME_SEGMENT_IDS = {
  MACHINES_LIVE_OVERVIEW: 'welcome-machines-live-overview',
  MACHINES_NC_FILE: 'welcome-machines-nc-file',
  WALLBOARD: 'welcome-wallboard',
  MACHINES_BATCH: 'welcome-machines-batch',
  MACHINES_TIMELINE: 'welcome-machines-timeline',
  MACHINES_PERFORMANCE: 'welcome-machines-performance',
  OPERATOR_PANEL: 'welcome-operator-panel',
  OPERATOR_PANEL_SCHEDULED: 'welcome-operator-panel-scheduled',
} as const;

// Demo IDs for welcome tour - use 999990xxx range to avoid conflicts
export const DEMO_WELCOME_MACHINE_ID = 999990100;
export const DEMO_ID_THRESHOLD = 999990000;

// Demo entity IDs
export const DEMO_BATCH_ID = 999990101;
export const DEMO_NC_FILE_ID = 999990102;
export const DEMO_PART_ID = 999990103;
export const DEMO_OPERATION_ID = 999990110;
export const DEMO_PRODUCTION_ORDER_ID = 999990111;

// Welcome-specific tour target IDs (unique — avoids conflict with local batch tour targets)
export const WELCOME_TOUR_IDS = {
  // Live Overview block IDs
  LIVE_TOP_BLOCK: 'welcome-live-top-block',
  LIVE_BATCH_BLOCK: 'welcome-live-batch-block',
  LIVE_ACTIVITY_BLOCK: 'welcome-live-activity-block',
  LIVE_OEE_BLOCK: 'welcome-live-oee-block',
  LIVE_TOOLS_BLOCK: 'welcome-live-tools-block',
  LIVE_NC_FILE_BLOCK: 'welcome-live-nc-file-block',

  // Legacy IDs (still used by TourTarget wrappers in sub-screens)
  BATCH_DETAILS: 'welcome-batch-details',
  BATCH_TAB: 'welcome-batch-tab',
  BATCH_INFO: 'welcome-batch-info',
  BATCH_LINK: 'welcome-batch-link',
  BATCH_READY: 'welcome-batch-ready',
  BATCH_PRODUCTIVITY: 'welcome-batch-productivity',
  BATCH_STATUS_ROW: 'welcome-batch-status-row',
  TIMELINE_OVERVIEW: 'welcome-timeline-overview',
  TIMELINE_COUNTS: 'welcome-timeline-counts',
  TIMELINE_SCALE: 'welcome-timeline-scale',
  NC_FILE_TAB: 'welcome-nc-file-tab',
  NC_FILE_NAME: 'welcome-nc-file-name',
  NC_FILE_TYPE: 'welcome-nc-file-type',
  NC_FILE_CONTENT: 'welcome-nc-file-content',
  PERFORMANCE_CHART: 'welcome-performance-chart',
  PERFORMANCE_TABS: 'welcome-performance-tabs',
  PERFORMANCE_BAR_CHART: 'welcome-performance-bar-chart',
  OP_NC_FILE_INFO: 'welcome-op-nc-file-info',
  OP_COUNTER: 'welcome-op-counter',
  OP_BOTTOM_ACTIONS: 'welcome-op-bottom-actions',
  OP_SCHEDULED_OVERVIEW: 'welcome-op-scheduled-overview',
  OP_SCHEDULED_JOB_TILE: 'welcome-op-scheduled-job-tile',
} as const;
